import * as React from 'react';
import { Chip, ChipProps, darken } from '@mui/material';
import { Preference, DEFAULT_PREFERENCE_COLOR } from '../../types/Preference';
import { expandShortHex, getContrastingText } from '../../utility/preferenceColor';

type Props = Omit<ChipProps, 'label' | 'color'> & Pick<Preference, 'value' | 'color'>;

export default function PreferencePill({ value, color, size = 'small', ...otherProps }: Props) {
  const label = value ?? '';
  if (!label) return null;

  const bg = expandShortHex(color || undefined) ?? DEFAULT_PREFERENCE_COLOR;
  const fg = getContrastingText(bg);
  const border = darken(bg, 0.2);

  return (
    <Chip
      {...otherProps}
      size={size}
      label={label}
      sx={{
        ...otherProps.sx,
        bgcolor: bg,
        color: fg,
        border: `1px solid ${border}`,
        borderRadius: 1.3,
        '& .MuiChip-label': { px: 1, fontWeight: 500 },
      }}
    />
  );
}
